module.exports = __webpack_public_path__ + "static/contact-1d9eef06c3e60eb6df5c3e8fa6b97190.jpg";